import { useState } from "react"
import "./ContactPage.css"
import { otpApiUrl } from "../../../config/api.js"
import { devLog } from "../../../config/devLog.js"

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  })
  const [status, setStatus] = useState("")
  const [isSubmitting, setIsSubmitting] = useState(false)

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setIsSubmitting(true)

    // Simulate form submission
    await sendUpdatetoservice(formData)
    setStatus("Thank you! Your message has been received. We'll get back to you soon.")
    setFormData({ name: "", email: "", message: "" })
    setTimeout(() => setStatus(""), 5000)
    setIsSubmitting(false)
  }


  const sendUpdatetoservice = async (formData) =>{
      const emailContent = {
        email: 'corporateNRIservice@gmail.com',
        subject: "A user Contacted",
        text: `Hello,

        There is a new Enquiry/Suggestion from a user, here are the details

        Name - ${formData.name},

        Email - ${formData.email},

        Message - ${formData.message}

      Best regards,
         Team Corporate NRI`, 
        html: `
        <div style="font-family: Arial, sans-serif; line-height: 1.5; color: #333;">
          <p>Hello,</p>
          
          <p>There is a new Enquiry/Suggestion from a user, here are the details.</p>

            <p>Name - ${formData.name}</p>

            <p>Email - ${formData.email}</p>

            <p>Message - ${formData.message}</p>

          
          <p>Best regards,<br>
          <strong>Team Corporate NRI</strong></p>
        </div>`
      };
    const response = await fetch(otpApiUrl("sendMail"),{method:"POST", headers: {
      'Content-Type': 'application/json',
    },body:JSON.stringify(emailContent)})
    await response.json();
    devLog("[contact] sendMail", { ok: response.ok })
   
  }

  return (
    <div className="page-container">
    

      {/* Main Content */}
      <main className="main-content">
        <h2 className="page-title">Contact Us</h2>
        <p className="page-description">
          We're here to assist you with any questions or support you need. Reach out to our team or connect with the
          Corporate NRIs community!
        </p>

        <div className="content-grid">
          {/* Contact Form */}
          <div className="form-section">
            <h3 className="section-title">Send Us a Message</h3>
            <form onSubmit={handleSubmit} className="contact-form">
              <div className="form-group">
                <label htmlFor="name" className="form-label">
                  Name
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  className="form-input"
                  placeholder="Your Name"
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="email" className="form-label">
                  Email
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  className="form-input"
                  placeholder="Your Email"
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="message" className="form-label">
                  Message
                </label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  className="form-textarea"
                  placeholder="Your Message"
                  rows={5}
                  required
                />
              </div>

              <button type="submit" disabled={isSubmitting} className="submit-button">
                Send Message
              </button>

              {status && <p className="status-message">{status}</p>}
            </form>
          </div>

          {/* Contact Information */}
          <div className="info-section">
            <h3 className="section-title">Get in Touch</h3>
            <div className="contact-info">
              <div className="contact-item">
                <svg className="contact-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                  />
                </svg>
                <div>
                  <h4 className="contact-title">Email</h4>
                  <p className="contact-detail">support@corporatenri.com</p>
                </div>
              </div>

              <div className="contact-item">
                <svg className="contact-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M3 5a2 2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                  />
                </svg>
                <div>
                  {/* <h4 className="contact-title">Phone</h4> */}
                  {/* <p className="contact-detail">+91 9494939578</p> */}
                </div>
              </div>

              <div className="contact-item">
                <svg className="contact-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                  />
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                  />
                </svg>
                <div>
                  <h4 className="contact-title">Address</h4>
                  <p className="contact-detail">Madhapur, Hyderabad, Telangana, 500082</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  )
}

export default ContactPage
